import React from "react";
import { Check, AlertTriangle } from "lucide-react";

/**
 * Small badge that shows whether an athlete's coaching payment is active.
 * - paid_active === true  → burgundy-on-cream "Paid & Active" pill
 * - paid_active === false → red-on-cream "Unpaid" pill
 *
 * Props:
 *   paid: boolean
 *   size?: "sm" | "md"  default "sm"
 */
export default function PaymentStatusBadge({ paid, size = "sm" }) {
  const active = paid !== false;
  const cfg = active
    ? {
        label: "Paid & Active",
        cls: "text-emerald-800 bg-[#eaf5ee] border-emerald-800/30",
        Icon: Check,
      }
    : {
        label: "Unpaid",
        cls: "text-[var(--tir-burgundy)] bg-[#fbeae9] border-[var(--tir-burgundy)]/30",
        Icon: AlertTriangle,
      };
  const pad = size === "md" ? "px-2.5 py-1 text-[10px]" : "px-2 py-0.5 text-[9px]";
  return (
    <span
      className={`inline-flex items-center gap-1 tracking-[0.22em] uppercase font-semibold border ${cfg.cls} ${pad}`}
      data-testid={`payment-status-${active ? "paid" : "unpaid"}`}
    >
      <cfg.Icon size={size === "md" ? 12 : 10} />
      {cfg.label}
    </span>
  );
}
